import React from "react";
import pure from "recompose/pure";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

interface IDashboardIconProps extends SvgIconProps {
	viewbox?: string
}

let Dashboard = ({ viewbox, ...rest }: IDashboardIconProps) => (
	<SvgIcon {...rest} viewBox="0 0 33 33">
		<rect x="7" y="7" width="18" height="18" rx="2" strokeWidth="2" />
		<rect x="14" y="20" width="4" height="2" />
		<rect x="9" y="13" width="4" height="2" />
		<rect x="19" y="15" width="4" height="2" />
		<line x1="21" y1="10" x2="21" y2="22" strokeWidth="2" />
		<line x1="16" y1="10" x2="16" y2="22" strokeWidth="2" />
		<line x1="11" y1="10" x2="11" y2="22" strokeWidth="2" />
	</SvgIcon>
);

// @ts-ignore
Dashboard = pure(Dashboard);
// @ts-ignore
Dashboard.displayName = "DashboardIcon";
// @ts-ignore
Dashboard.muiName = "SvgIcon";

export default Dashboard;
